/**
 * Shipper HQ
 *
 * @copyright Copyright (c) 2026 Zowta Ltd (http://www.shipperhq.com)
 * Copyright, 2026, Zowta, LLC - US license
 */

import React from 'react'
import LoginForm from './LoginForm'
import BackButton from './BackButton'
import { useRedirectIfLoggedIn } from './hooks/useRedirectIfLoggedIn'
import { BrandsPanel } from './BrandsPanel'

export default function LoginPage() {
    useRedirectIfLoggedIn()

    return (
        <main className="login-page">
            <section>
                <BackButton />
                <LoginForm />
            </section>
            <aside>
                <BrandsPanel headline />
            </aside>
        </main>
    )
}
